export const removeComma = (number) => {
    if (!isNaN(number)) { return number }
    return number === "" ? 0 : number.replace(/,/g, '')
}